import { 
  CREATE_JOURNAL_VOUCHER_MULTY, 
  GET_JOURNAL_VOUCHER_MULTY, 
  GET_JOURNAL_VOUCHER_MULTY_PAGE,
  JOURNAL_VOUCHER_MULTY_REQUEST,
  DELETE_JOURNAL_VOUCHER_MULTY,
  UPDATE_JOURNAL_VOUCHER_MULTY, 
  JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE, 
  JOURNAL_VOUCHER_MULTY_REQUEST_SUCCESS
} from "../types";

const initialState = {
    journalVoucherMultys: [],
    journalVoucherMultysPage: [],
    page: 1,
    pageSize: 10,
    search: '',
    showTaxJv: false,
    where: {},
    total: 0,
    loading: false,
    error: null,
  };

const journalVoucherMultyReducer = (state = initialState, action) => {
  switch (action.type) {
    case JOURNAL_VOUCHER_MULTY_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_JOURNAL_VOUCHER_MULTY: {
      return {
        ...state,
        journalVoucherMultys: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_JOURNAL_VOUCHER_MULTY_PAGE: {
        const { data, total, page, pageSize, search, showTaxJv, where } = action.payload || {};
        return {
          ...state,
          journalVoucherMultysPage: [...data],
          total,
          page,
          pageSize,
          showTaxJv: showTaxJv || false,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
    }
    case CREATE_JOURNAL_VOUCHER_MULTY: {
      return {
        ...state,
        journalVoucherMultys: [action.payload, ...state.journalVoucherMultys],
        loading: false,
        error: null
      };
    }
    case UPDATE_JOURNAL_VOUCHER_MULTY: {
      const journalVoucherMultysData = state.journalVoucherMultys.slice(0);
      const uIndex = journalVoucherMultysData.findIndex((data) => data.id === action.payload.id);
      journalVoucherMultysData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        journalVoucherMultys: [ ...journalVoucherMultysData ],
        loading: false,
        error: null
      };
    }
    case DELETE_JOURNAL_VOUCHER_MULTY: {
      const journalVoucherMultys = state.journalVoucherMultys?.slice(0);
      const index = journalVoucherMultys.findIndex((data) => data.id === action.id);
      if (index > -1) {
          journalVoucherMultys.splice(index, 1);
      }
      return {
        ...state,
        journalVoucherMultys: [...journalVoucherMultys],
        loading: false,
        error: null
      }
    }
    case JOURNAL_VOUCHER_MULTY_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
    case JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default journalVoucherMultyReducer;